
import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import './plugins/bootstrap-vue'
import '@babel/polyfill'
import 'mutationobserver-shim'
import router from './router'
import store from './store'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import specific icons */
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* add icons to the library */
library.add(faUserSecret)

import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
Vue.use(axios);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
// Vue.use(VueApexCharts)
// Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
